module.exports = __webpack_public_path__ + "media/images/brands/marque-revlon@2x-6cbfbc494ad62d7f9a77119226093815.jpg";